import DashboardContainer from '@sh/containers/DashboardContainer.vue';
// import session from '@sh/services/session';

// Pages
import Login from '@sh/views/Pages/Login.vue';
// import Register from '@sh/views/Pages/Register.vue';
import Page404 from '@sh/views/Pages/Page404.vue';
import Page500 from '@sh/views/Pages/Page500.vue';

// Components
import Dashboard from '@sh/views/Dashboard/Dashboard.vue';
import Campaigns from '@/views/Campaigns/Campaigns.vue';

import Campaign from '@/views/Campaign/Campaign.vue';

import AccountWizard from '@sh/views/Accounts/AccountWizard/Index';
import Trackers from '@sh/views/Accounts/Trackers/Index.vue';
import TrafficSources from '@sh/views/Accounts/TrafficSources/Index.vue';

import Rules from '@sh/views/Rules/Index.vue';
import Rule from '@sh/views/Rules/Rule';
import ruleConfig from '@/views/Automation/Rules/config';

import SystemActivityPage from '@/views/Tools/SystemActivity/SystemActivityPage.vue';
import ManualStatsUpdate from '@/views/Tools/ManualStatsUpdate/Index.vue';
import ManualConnection from '@sh/views/Tools/ManualConnection/ManualConnection';

import Reporting from '@/views/Tools/Reporting/Index';

import Settings from '@sh/views/Tools/Settings/Settings';
import Profile from '@sh/views/Profile/Profile';
import SubuserRegister from '@sh/views/Pages/SubuserRegister';
import SubuserChangePassword from '@sh/views/Pages/SubuserChangePassword';

import GotoComponent from '@sh/components/Utils/GotoComponent';
import session from '@sh/services/session';
import router from '@sh/services/router';

const notLogged = (to, from, next) => {
  if (to.query.token) {
    const jwt = localStorage.getItem('jwt-token');
    if (jwt) {
      session.removeToken();
    }
    session.setToken(to.query.token);
  }
  if (session.isAuthenticated()) {
    return next({ name: 'Home' });
  }
  next();
};

const routes = [
  {
    path: '/',
    redirect: { name: 'Dashboard' },
    name: 'Home',
    component: DashboardContainer,
    beforeEnter: (to, from, next) => (!session.isAuthenticated() ? next({ name: 'Login' }) : next()),
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
      },
      {
        path: 'campaigns',
        name: 'Campaigns',
        component: Campaigns,
      },
      {
        path: 'campaign/:id/:type',
        name: 'Campaign',
        component: Campaign,
      },
      {
        path: 'rules',
        name: 'Rules',
        component: Rules,
        props: { configFile: ruleConfig },
      },
      {
        path: 'rules/new',
        name: 'New Rule',
        component: Rule,
        props: { configFile: ruleConfig, mode: 'create', afterCreate: () => { router.push({ name: 'Rules' }); } },
      },
      {
        path: 'rules/:id/edit',
        name: 'Edit Rule',
        component: Rule,
        props: { configFile: ruleConfig, mode: 'edit' },
      },
      {
        path: 'rules/:id/clone',
        name: 'Clone Rule',
        component: Rule,
        props: { configFile: ruleConfig, mode: 'clone', afterCreate: () => { router.push({ name: 'Rules' }); } },
      },
      {
        path: 'system-activity',
        name: 'SystemActivityPage',
        component: SystemActivityPage,
      },
      {
        path: 'account-wizard',
        name: 'AccountWizard',
        component: AccountWizard,
      },
      {
        path: 'account-wizard/reload',
        name: 'GotoAccountWizard',
        component: GotoComponent,
        props: { to: '/account-wizard' },
      },
      {
        path: 'traffic-sources',
        name: 'TrafficSources',
        component: TrafficSources,
      },
      // {
      //   path: 'traffic-sources/:id/edit',
      //   name: 'EditTrafficSource',
      //   component: EditTrafficSource,
      // },
      {
        path: 'trackers',
        name: 'Trackers',
        component: Trackers,
      },
      // {
      //   path: 'trackers/:id/edit',
      //   name: 'EditTracker',
      //   component: EditTracker,
      // },
      {
        path: 'manual-connection',
        name: 'ManualConnection',
        component: ManualConnection,
      },
      {
        path: 'reporting',
        name: 'Reporting',
        component: Reporting,
      },
      {
        path: 'manual-stats-update',
        name: 'ManualStatsUpdate',
        component: ManualStatsUpdate,
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: notLogged,
  },
  {
    path: '/register',
    name: 'SubuserRegister',
    component: SubuserRegister,
  },
  {
    path: '/change_password',
    name: 'SubuserChangePassword',
    component: SubuserChangePassword,
  },
  {
    path: '/500',
    name: 'Page500',
    component: Page500,
  },
  {
    path: '*',
    name: 'Page404',
    component: Page404,
  },
];

// if (process.env.VUE_APP_ENABLE_NOTIFICATIONS) {
//   routes[0].children.push({
//     path: 'settings',
//     name: 'Settings',
//     component: Settings,
//   });
//   routes[0].children.push({
//     path: 'notifications',
//     name: 'Notifications',
//     component: Notifications,
//   });
// }

export default routes;
